var BlendModeSoftware = /** @class */ (function () {
    function BlendModeSoftware() {
    }
    BlendModeSoftware.destinationAlpha = function (result, target, dest, source) {
        result[0] = target[0] * dest[3] / 0xFF;
        result[1] = target[1] * dest[3] / 0xFF;
        result[2] = target[2] * dest[3] / 0xFF;
        result[3] = target[3] * dest[3] / 0xFF;
    };
    BlendModeSoftware.destinationColor = function (result, target, dest, source) {
        result[0] = target[0] * dest[0] / 0xFF;
        result[1] = target[1] * dest[1] / 0xFF;
        result[2] = target[2] * dest[2] / 0xFF;
        result[3] = target[3] * dest[3] / 0xFF;
    };
    BlendModeSoftware.one = function (result, target, dest, source) {
        result[0] = target[0];
        result[1] = target[1];
        result[2] = target[2];
        result[3] = target[3];
    };
    BlendModeSoftware.oneMinusDestinationAlpha = function (result, target, dest, source) {
        result[0] = target[0] * (1 - dest[3] / 0xFF);
        result[1] = target[1] * (1 - dest[3] / 0xFF);
        result[2] = target[2] * (1 - dest[3] / 0xFF);
        result[3] = target[3] * (1 - dest[3] / 0xFF);
    };
    BlendModeSoftware.oneMinusDestinationColor = function (result, target, dest, source) {
        result[0] = target[0] * (1 - dest[0] / 0xFF);
        result[1] = target[1] * (1 - dest[1] / 0xFF);
        result[2] = target[2] * (1 - dest[2] / 0xFF);
        result[3] = target[3] * (1 - dest[3] / 0xFF);
    };
    BlendModeSoftware.oneMinusSourceAlpha = function (result, target, dest, source) {
        result[0] = target[0] * (1 - source[3] / 0xFF);
        result[1] = target[1] * (1 - source[3] / 0xFF);
        result[2] = target[2] * (1 - source[3] / 0xFF);
        result[3] = target[3] * (1 - source[3] / 0xFF);
    };
    BlendModeSoftware.oneMinusSourceColor = function (result, target, dest, source) {
        result[0] = target[0] * (1 - source[0] / 0xFF);
        result[1] = target[1] * (1 - source[1] / 0xFF);
        result[2] = target[2] * (1 - source[2] / 0xFF);
        result[3] = target[3] * (1 - source[3] / 0xFF);
    };
    BlendModeSoftware.sourceAlpha = function (result, target, dest, source) {
        result[0] = target[0] * source[3] / 0xFF;
        result[1] = target[1] * source[3] / 0xFF;
        result[2] = target[2] * source[3] / 0xFF;
        result[3] = target[3] * source[3] / 0xFF;
    };
    BlendModeSoftware.sourceColor = function (result, target, dest, source) {
        result[0] = target[0] * source[0] / 0xFF;
        result[1] = target[1] * source[1] / 0xFF;
        result[2] = target[2] * source[2] / 0xFF;
        result[3] = target[3] * source[3] / 0xFF;
    };
    BlendModeSoftware.zero = function (result, target, dest, source) {
    };
    return BlendModeSoftware;
}());
export { BlendModeSoftware };
